
import { createApiClient } from 'Network/ApiClient';
  
  export const MedicalIcdAxiosInstance = createApiClient('medicalicd/');


